import { Component, Input } from '@angular/core';
import { Transaction } from '../transactions.models';

@Component({
  standalone: false,
  selector: 'dsp-mobile-transaction-opening-card',
  templateUrl: 'mobile-opening-card.component.html',
  styleUrls: [ 'mobile-opening-card.component.scss' ]
})
export class MobileOpeningCardComponent {
  @Input() public transaction: Transaction;
}
